webpackJsonp([146230036245944],{

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _internetOfThings = __webpack_require__(798);
	
	var _internetOfThings2 = _interopRequireDefault(_internetOfThings);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _CheckModule = __webpack_require__(32);
	
	var _CheckModule2 = _interopRequireDefault(_CheckModule);
	
	var _box = __webpack_require__(787);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _iotCloud = __webpack_require__(799);
	
	var _iotCloud2 = _interopRequireDefault(_iotCloud);
	
	var _RightPicture = __webpack_require__(33);
	
	var _RightPicture2 = _interopRequireDefault(_RightPicture);
	
	var _objetsConnectes = __webpack_require__(806);
	
	var _objetsConnectes2 = _interopRequireDefault(_objetsConnectes);
	
	var _technologies = __webpack_require__(42);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _symfony = __webpack_require__(41);
	
	var _symfony2 = _interopRequireDefault(_symfony);
	
	var _nodejs = __webpack_require__(40);
	
	var _nodejs2 = _interopRequireDefault(_nodejs);
	
	var _angularReact = __webpack_require__(37);
	
	var _angularReact2 = _interopRequireDefault(_angularReact);
	
	var _baseDeDonnee = __webpack_require__(38);
	
	var _baseDeDonnee2 = _interopRequireDefault(_baseDeDonnee);
	
	var _elasticsearch = __webpack_require__(67);
	
	var _elasticsearch2 = _interopRequireDefault(_elasticsearch);
	
	var _htmlCssJs = __webpack_require__(39);
	
	var _htmlCssJs2 = _interopRequireDefault(_htmlCssJs);
	
	var _ApplicationIotModule = __webpack_require__(422);
	
	var _ApplicationIotModule2 = _interopRequireDefault(_ApplicationIotModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationIot = function (_Component) {
	    _inherits(ApplicationIot, _Component);
	
	    function ApplicationIot() {
	        _classCallCheck(this, ApplicationIot);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ApplicationIot.prototype.render = function render() {
	        var title = "Application Web";
	        var goto = "En découvrir plus";
	        var alt = "test";
	        var description = ["Fort de notre expérience dans le ", _react2.default.createElement(
	            "strong",
	            null,
	            "domaine de l'embarqu\xE9"
	        ), " et dans le milieu de l'industrie", " nous réalisons des ", _react2.default.createElement(
	            "strong",
	            null,
	            "applications web, mobile ou embarqu\xE9e"
	        ), " dédiées au monde l'Internet des objets."];
	
	        var smalltitle = "Le meilleur du matériel et du logiciel";
	        var titlemethodo = "une solution matérielle et logicielle sur-mesure pour vos objets connectés";
	        var descriptionmethodo = ["Notre expertise applicative couplée à notre savoir-faire dans l'informatique industrielle vous apporte une solution globale et cohérente pour la mise en place d'une solution sécurisée et fiable.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Nos réalisations sont sur-mesure et adaptées à vos besoins, afin que l'ensemble de la solution corresponde à 100% à vos attentes sans superflu."];
	        var pictureMethodo = _box2.default;
	        var altmethodo = "Méthodologie agile Scrum en image";
	
	        var smalltitleevol = "Les objets connectés au coeur de votre infrastructure";
	        var titleevol = "Des applications Web robustes pour vos infrastructures IoT";
	        var descriptionevol = ["Nous réalisons des applications dédiées au monde des objets connectés qui répondent à vos contraintes (Volumétrie, faible latence, faible débit, ...).", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Grâce à nos méthodologies de développement éprouvées, nous concevons des applications sécurisées et robustes."];
	
	        var altevol = "Intégration du portail dans votre système d'information";
	
	        var smalltitleCheck = "Le cloud s'invite dans votre industrie";
	        var titleCheck = "L'expertise industrielle au travers d'application IoT orienté Cloud";
	        var subtitle1Check = "Collecter";
	        var text1Check = ["Nos applications peuvent récolter de grands volumes de données à partir de vos objets connectés. Nous utilisons les services Cloud (AWS Amazon ou Microsoft Azure) ou des infrastructures spécifiques."];
	        var subtitle2Check = "Analyser";
	        var text2Check = ["Analyser et visualiser de grands volumes de données qui suivent l'évolution de vos objets. Nous réalisons des ", _react2.default.createElement(
	            "a",
	            { href: "/portail-web-collaboratif", title: "Les portails Web" },
	            "portails"
	        ), " et des ", _react2.default.createElement(
	            "a",
	            { href: "/application-mobile", title: "Applications mobiles" },
	            "applications mobiles"
	        ), " spécifiques de suivi pour vous, vos clients et/ou vos partenaires!"];
	        var subtitle3Check = "Agir";
	        var text3Check = ["Facilitez ou automatisez la prise de décision et l'action envers votre infrastructure IoT."];
	        var pictureCheck = _iotCloud2.default;
	        var altCheck = "L'IoT facile";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "generic-services" },
	            _react2.default.createElement(_MainPicture2.default, { title: "L'innovation au coeur de l'IoT", description: description, picture: _internetOfThings2.default, alt: alt }),
	            _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _objetsConnectes2.default, alt: altevol }),
	            _react2.default.createElement(_LeftPictureBackground2.default, { smalltitle: smalltitle, title: titlemethodo, description: descriptionmethodo, picture: pictureMethodo, alt: altmethodo }),
	            _react2.default.createElement(_CheckModule2.default, {
	                smalltitle: smalltitleCheck,
	                title: titleCheck,
	                subtitle1: subtitle1Check,
	                text1: text1Check,
	                subtitle2: subtitle2Check,
	                text2: text2Check,
	                subtitle3: subtitle3Check,
	                text3: text3Check,
	                picture: pictureCheck,
	                alt: altCheck
	            }),
	            _react2.default.createElement(
	                "section",
	                { className: _ApplicationIotModule2.default.iot + " row-bottom-padded-lg row-top-padded-lg" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "container" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "row align-items-center" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col text-center" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                "Votre \xE9cosyst\xE8me IoT propuls\xE9 par nos solutions"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                "Nous avons cr\xE9\xE9 des outils de configuration, pilotage et d'analyse d'infrastructure IoT \xE0 l'aide des ",
	                                _react2.default.createElement(
	                                    "a",
	                                    { href: "https://www.integral-system.fr/fr_FR/taxons/iot-sans-fil-adm2", title: "Modules d'acquisition de donn\xE9es industriels", target: "_blank" },
	                                    "modules d'acquisitions de donn\xE9es WISE 4000"
	                                ),
	                                ". Sous forme de modules Web (Passerelle IoT), retrouvez et analysez vos donn\xE9es directement dans notre portail Web m\xE9tier !"
	                            ),
	                            _react2.default.createElement(
	                                "a",
	                                { href: "/contact", title: "Contacter Integral Service", className: "btn btn-primary " + _ApplicationIotModule2.default.btnwrappre },
	                                "N'h\xE9sitez pas \xE0 nous contacter pour en savoir plus !"
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ApplicationIot;
	}(_react.Component);
	
	exports.default = ApplicationIot;
	module.exports = exports["default"];

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"iot":"src-components-Page----ApplicationIot-module---iot---3mdo7","btnwrappre":"src-components-Page----ApplicationIot-module---btnwrappre---qEAAd"};

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/box.15661699.png";

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/internet-of-things.4b3af02b.png";

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iot-cloud.145ddb6b.jpg";

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/objets-connectes.504eb5e0.jpg";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _ApplicationIot = __webpack_require__(286);
	
	var _ApplicationIot2 = _interopRequireDefault(_ApplicationIot);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _iot = __webpack_require__(181);
	
	var _iot2 = _interopRequireDefault(_iot);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationIotApp = function (_Component) {
	    _inherits(ApplicationIotApp, _Component);
	
	    function ApplicationIotApp() {
	        _classCallCheck(this, ApplicationIotApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ApplicationIotApp.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Création d'application IoT (Internet des objets)",
	                "description": "Integral Service développe des applications compatibles avec les objets connectés et qui apporte une réelle plus value à l'internet des objets.",
	                "cover": _iot2.default
	            }
	        };
	
	        var title = "Application IoT";
	        var description = "Des applications pour l'internet des objets";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Cr\xE9ation d'application IoT (Internet des objets) | " + _SiteConfig2.default.siteTitle,
	                description: "Integral Service d\xE9veloppe des applications compatibles avec les objets connect\xE9s et qui apporte une r\xE9elle plus value \xE0 l'internet des objets."
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _iot2.default }),
	            _react2.default.createElement(_ApplicationIot2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return ApplicationIotApp;
	}(_react.Component);
	
	exports.default = ApplicationIotApp;
	
	;
	module.exports = exports["default"];

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iot.f0f42b3a.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-application-iot-jsx-eeaee08780daaf19cb87.js